function isJson(value) {
  if (typeof value !== 'string') return false;
  try {
    JSON.parse(value);
  } catch (err) {
    return false;
  }
  return true;
}

export default class EntityHelper {
  static hasTranslations(obj, locale) {
    return locale && obj.translations && obj.translations[locale];
  }

  static validateData(data) {
    if (typeof data !== 'object' || Array.isArray(data) || data === null) throw new Error('Parameter should be a literal object.');
    return true;
  }

  static setTranslations(value) {
    if (!Array.isArray(value) && typeof value === 'object') return value;
    if (!isJson(value)) return {};
    return JSON.parse(value);
  }

  /**
   * When no id is set we can chose a default value
   * @param value
   * @param defaultValue
   * @returns {string}
   */
  static setId(value, defaultValue = '') {
    const isInvalid = !['number', 'string'].includes(typeof value);

    if (isInvalid) return defaultValue;

    return value.toString();
  }
}
